import { Component, forwardRef, OnInit } from '@angular/core';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SimulationDao } from '@app/dao/simulation/simulation.dao';
import { SimulationType } from '@app/dao/simulation/simulation.interface';
import * as _ from 'lodash';
import { Subject } from 'rxjs';
import { EaSimulationPinelFormBuilder } from './ea-simulation-pinel-form.builder';

@Component({
    selector: 'ea-simulation-pinel-form',
    templateUrl: './ea-simulation-pinel-form.component.html',
    styleUrls: ['./ea-simulation-pinel-form.component.scss'],
    providers: [
        {
            provide: PrFormAbstract,
            useExisting: forwardRef(() => EaSimulationPinelFormComponent),
        },
    ],
    standalone: false
})
export class EaSimulationPinelFormComponent
  extends EaSimulationPinelFormBuilder
  implements OnInit
{
  doneSubject: Subject<void> = new Subject<void>();

  pinelDurations = [
    {
      label: '6 ans',
      duration: 6,
      rate: 0.02,
    },
    {
      label: '9 ans',
      duration: 9,
      rate: 0.02,
    },
    {
      label: '12 ans',
      duration: 12,
      rate: 0.0175,
    },
  ];

  constructor(
    protected formConstructor: PrFormConstructor,
    private simulationDao: SimulationDao,
  ) {
    super(formConstructor);
  }

  ngOnInit() {}

  onRentalCommitmentInYearsChange(event) {
    this.form.controls.simulationDurationInYears.setValue(event.value + 2);
    this.onProjectDurationChange();
  }

  onProjectDurationChange() {
    if (
      this.form.get('loanDuration').value &&
      this.form.get('rentalCommitmentInYears').value >
        this.form.get('loanDuration').value / 12
    ) {
      if (this.form.get('loanDuration').value / 12 >= 12)
        this.form.get('rentalCommitmentInYears').setValue(12);
      else if (this.form.get('loanDuration').value / 12 >= 9)
        this.form.get('rentalCommitmentInYears').setValue(9);
      else this.form.get('rentalCommitmentInYears').setValue(6);
    }
  }

  onSubmit() {
    this.prFormService.loading();
    this.simulationDao
      .simulate(null, SimulationType.PINEL, this.extract())
      .subscribe(
        success => {
          this.prFormService.loaded();
          this.doneSubject.next();
          if (this.callback) this.callback(success);
          this.notificationService.success('La simulation a réussi');
        },
        errors => {
          console.error(errors);
          this.prFormService.loaded();
          this.notificationService.error('La simulation a échoué');
        },
      );
  }
}
